import { render, staticRenderFns } from "./skuImage.vue?vue&type=template&id=0653b3d6&"
import script from "./skuImage.vue?vue&type=script&lang=ts&"
export * from "./skuImage.vue?vue&type=script&lang=ts&"
import style0 from "./skuImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports